

































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  EventsApi, EventNew, UnitsApi,
} from '@compassdigital/foodworks.ts.sdk';
import Textfield from '@/components/Form/Textfield/index.vue';
import TextButton from '@/components/Buttons/TextButton/index.vue';
import NonWorkignEditDays from '@/components/Form/NonWorkingDays/NonWorkignEditDays/index.vue';
import NonWorkingDelete from '@/components/Modal/NonWorkingDelete/index.vue';
import Format from '@/util/Format';
import AppModule from '@/store/modules/app';
import UserModule from '@/store/modules/user';
import UnitsUtil from '@/util/UnitUtil';
import ToastModule from '@/store/modules/toast';
import moment from 'moment';

@Component({
  components: {
    Textfield,
    TextButton,
    NonWorkignEditDays,
    NonWorkingDelete,
  },
})
export default class NonWorkingDays extends Vue {
  @Prop() unitID!: string;

  public edit: boolean = false;

  public addNewDay: boolean = false;

  public updatedDate: any = '';

  public saving: boolean = false;

  public openDeleteModal: boolean = false;

  public nonWorkingDaysEvents: EventNew = {};

  public selectedEventsDays: EventNew = {};

  public eventID: string = '';

  public isNew: boolean = false;

  public deleteEventDate: any = '';

  public deleteEventId: string = '';

  public loading: boolean = false;

  public error: string = '';

  public deleteError: string = '';

  public mounted() {
    this.getCurrentDate();
    this.getNonWorkingDays();
  }

  public getCurrentDate() {
    const currentDate = new Date();
    const oneDayAfterDate = currentDate.setDate(new Date(currentDate).getDate() + 1);
    const formattedDate = Format.getDatePickerFormatted(oneDayAfterDate);
    this.updatedDate = formattedDate;
  }

  private eventDetails: any = {
    date: null,
    type: 'non-working',
    unitID: this.unitID,
    status: 'active',
    meta: {
      createdByUserId: this.userID,
      reason: '',
      description: '',
    },
  }

  get userID() {
    return UserModule.userId;
  }

  public onClose() {
    this.edit = false;
    this.addNewDay = false;
    this.eventDetails.meta.description = '';
    this.eventDetails.meta.reason = '';
    this.eventDetails.meta.createdByUserId = '';
    this.eventID = '';
    this.eventDetails.date = '';
    this.error = '';
  }

  public onClickEventEdit(id: string) {
    this.eventID = id;
    this.getSelectedIdDays(id, this.nonWorkingDaysEvents);
    this.edit = true;
  }

  public getSelectedIdDays(eventID: string, allEventsDays: any) {
    const mappedDays = allEventsDays.find((value: any) => value.id === eventID);
    this.selectedEventsDays = mappedDays;
  }

  public AddEventDay() {
    this.addNewDay = true;
    this.isNew = true;
    this.edit = true;
  }

  public async getNonWorkingDays() {
    try {
      this.saving = true;
      const date = new Date();
      const formattedDate = Format.getDatePickerFormatted(date);
      const end: string = moment().add(5, 'year').format('YYYY-MM-DD');
      const nullDate: any = undefined;
      const api = new UnitsApi(AppModule.apiConfig);
      const events = await api.getUnitEvents(
        this.unitID, nullDate, formattedDate, end,
      );
      const mappedEvents = UnitsUtil.getMappedEvents(events.data);
      (this.nonWorkingDaysEvents as any) = mappedEvents;
    } catch (error) {
      const { message } = error.response.data.error;
      const errorMessage = message;
      ToastModule.setToast({
        message: errorMessage,
        timeout: 5000,
      });
    }
    this.saving = false;
  }

  public async onSaveNewEvent() {
    if ((this.$refs.form as any).validate()) {
      try {
        this.saving = true;
        const eventData: EventNew[] = [{
          unitId: this.unitID,
          date: this.eventDetails.date,
          type: this.eventDetails.type,
          meta: this.eventDetails.meta,
          status: this.eventDetails.status,
        }];
        const api = new EventsApi(AppModule.apiConfig);
        const events: any = await api.createEvent(eventData as any);
        if (events.data) {
          this.isNew = false;
          this.edit = false;
          this.getNonWorkingDays();
          this.eventDetails.date = '';
          this.eventDetails.meta.reason = '';
          this.eventDetails.meta.description = '';
        }
      } catch (error) {
        const { message } = error.response.data.error;
        const errorMessage = message;
        ToastModule.setToast({
          message: errorMessage,
          timeout: 5000,
        });
      }
      this.saving = false;
    }
  }

  public async onSaveUpdateEvent() {
    if ((this.$refs.form as any).validate()) {
      try {
        this.loading = true;
        const eventInfo = { ...this.selectedEventsDays };
        const { id } = eventInfo;
        const api = new EventsApi(AppModule.apiConfig);
        const events: any = await api.patchEvent(id as string, eventInfo);
        if (events.data) {
          this.edit = false;
          this.eventID = '';
          this.getNonWorkingDays();
        }
      } catch (error) {
        const { message } = error.response.data.error;
        const errorMessage = message;
        ToastModule.setToast({
          message: errorMessage,
          timeout: 5000,
        });
      }
      this.loading = false;
    }
  }

  public onClickDelete(eventId: string) {
    this.deleteEventId = eventId;
    this.openDeleteModal = true;
    const date = new Date();
    const formattedDate = Format.getFomattedDate(date);
    this.deleteEventDate = formattedDate;
  }

  public async onOptionDelete() {
    if ((this.$refs.form as any).validate()) {
      try {
        this.loading = true;
        const api = new EventsApi(AppModule.apiConfig);
        const events: any = await api.deleteEvent(this.deleteEventId as string);
        if (events) {
          this.openDeleteModal = false;
          this.getNonWorkingDays();
        }
      } catch (error) {
        const { message } = error.response.data.error;
        this.deleteError = message;
      }
    }
    this.loading = false;
  }

  public onOptionCancel() {
    this.openDeleteModal = false;
    this.deleteError = '';
  }
}
